export function customSort<T>(
    currentSort: string,
    currentSortOrder: string,
    value:T[]
):T[] {
    return value.sort(dynamicSort(currentSort, currentSortOrder));
}

export function getNumber(item: any) {
    return isNaN(item) ? Number(item.split(' ')[0]) : item
}

export function capitalize(s: string) {
    return s[0].toUpperCase() + s.slice(1);
}

export const declOfNum = (number: number, titles: Array<string>): string => {
    const cases = [2, 0, 1, 1, 1, 2];
    return number + ' ' + titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];
}

export function humanFileSize(size:number) {
    if (!size) return '';
    var i = Math.floor(Math.log(size) / Math.log(1024));
    return Number((size / Math.pow(1024, i)).toFixed(2)) + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
}

export function dynamicSort(currentSort: string, currentSortOrder: string) {
    return (a:any, b:any) => {
        const sortBy = currentSort;
        if (typeof a[sortBy] === 'number' || typeof b[sortBy] === 'number'){
            if (currentSortOrder === "desc") {
                if (a[sortBy] < b[sortBy]) return 1;
                if (a[sortBy] > b[sortBy]) return -1;
                if (!a[sortBy]) return 1;   // когда аттрибут не задан (напр. bulk_id undefined)
                if (!b[sortBy]) return -1;
            }
            if (a[sortBy] > b[sortBy]) return 1;
            if (a[sortBy] == b[sortBy]) return 0;
            if (a[sortBy] < b[sortBy]) return -1;
            if (!a[sortBy]) return -1;
            if (!b[sortBy]) return 1;
        }
        if (currentSortOrder === "desc") {
            if (!b[sortBy]) b[sortBy] = '';
            return b[sortBy].localeCompare(a[sortBy]);
        }
        if (!a[sortBy]) a[sortBy] = '';
        return a[sortBy].localeCompare(b[sortBy]);
    }
}

export function removeItem<T>(arr: T[]|undefined, value: T): T[] {
    if (arr) {
        const index = arr.indexOf(value);
        if (index > -1) {
            arr.splice(index, 1);
        }
        return arr;
    } else {
        return [];
    }
}

export function getLocale() {
    return localStorage.getItem('locale') === 'en' ? 'ENG' : 'RUS';
}